export default {
  '_b._qhyy': 'Vaihda kieli',

  '_a._jzz': 'Ladataan...',
  '_a._jzgd': 'Lataa lisää',
  '_a._wct': 'Tervetuloa',
  '_a._gd': 'Lisää',
  '_a._bf': 'Toista',
  '_a._bcz': 'Tallennetaan...',
  '_a._sctp': 'Lataa kuva',

  '_dl._qssyx': 'Syötä sähköpostiosoite',
  '_dl._qssmm': 'Syötä salasana',
  '_dl._ann': 'Kirjaudu sisään',
  '_dl._hmyzh': 'Eikö sinulla ole tiliä?',
  '_dl._qzc': 'Rekisteröidy',
  '_dl._yzhl': 'Onko sinulla jo tili?',
  '_dl._qdl': 'Kirjaudu sisään',
  '_dl._srqrmm': 'Vahvista salasana',
  '_dl._sryqm': 'Syötä kutsukoodi',
  '_dl._sryzm': 'Syötä vahvistuskoodi',
  '_dl._ljzc': 'Rekisteröidy nyt',
  '_dl._zcbsty': 'Rekisteröityminen tarkoittaa, että olet lukenut ja hyväksynyt',
  '_dl._yszc': 'Tietosuojakäytännön',
  '_dl._lcmmbyy': 'Salasanat eivät täsmää',

  '_yzm._fsyzm': 'Lähetä vahvistuskoodi',
  '_yzm._cxfs': '({time}) Lähetä uudelleen',
  '_yzm._fsz': 'Lähetetään...',
  '_yzm._fscg': 'Lähetetty onnistuneesti',

  '_h._zrm': 'Suosituin',
  '_h._zxd': 'Uusin',
  '_h._phb': 'Sijoitus',
  '_h._qz': 'Taustakuvat',
  '_h._ssww': 'Hae',
  '_h._lsjl': 'Historia',
  '_h._gd': 'Lisää',
  '_h._dl': 'Kirjaudu sisään',
  '_h._ye': 'Saldo',
  '_h._dj': 'Jäädytetty',
  '_h._ybp': 'Kojelauta',
  '_h._wdqb': 'Lompakkoni',
  '_h._scjl': 'Suosikit',
  '_h._xxzx': 'Viestikeskus',
  '_h._fxhy': 'Jaa ystävien kanssa',
  '_h._bzzx': 'Ohjekeskus',
  '_h._ggtf': 'Mainonnan sijoittaminen',
  '_h._bqtz': 'Tekijänoikeussijoitukset',
  '_h._sz': 'Asetukset',

  '_sy._jx': 'Suositellut',
  '_sy._xpfb': 'Uudet julkaisut',
  '_sy._gdsp': 'Lisää videoita',

  '_qz._jbqz': 'Hienostunut taustakuva-kokoelma',
  '_qz._ssqz': 'Hae taustakuvaa',
  '_qz._qb': 'Kaikki',
  '_qz._zrfg': 'Luonnonmaisemat',
  '_qz._cxys': 'Abstrakti taide',
  '_qz._csjz': 'Kaupunkiarkkitehtuuri',
  '_qz._dmyx': 'Anime & pelit',
  '_qz._yzxk': 'Kosmos & tähdet',
  '_qz._yl': 'Esikatsele',
  '_qz._xzqz': 'Lataa taustakuva',
  '_qz._fbl': 'Resoluutio',
  '_qz._fl': 'Kategoria',
  '_qz._jzz': 'Ladataan',
  '_qz._myzdpp': 'Sopivia taustakuvia ei löytynyt',

  '_sp._xyjscl': 'Lukituksen avaaminen vaaditaan katselua varten',
  '_sp._cz': 'Täytä saldoa',
  '_sp._jsqj': 'Avaa kaikki jaksot',
  '_sp._jsbj': 'Avaa tämä jakso',
  '_sp._sc': 'Suosikki',
  '_sp._fx': 'Jaa',
  '_sp._jsqjjs': 'Vahvista {a} maksu kaikkien jaksojen avaamiseksi?',
  '_sp._jsbjjs': 'Vahvista {a} maksu tämän jakson avaamiseksi?',
  '_sp._zfz': 'Käsitellään maksua...',
  '_sp._qrzf': 'Vahvista maksu',
  '_sp._qx': 'Peruuta',

  '_qz._smrc': 'Vuoriston auringonnousu',
  '_qz._cxjh': 'Abstrakti geometria',
  '_qz._dsyj': 'Kaupungin yömaisema',
  '_qz._dmfj': 'Anime-maisema',
  '_qz._hhxk': 'Laaja tähtitaivas',
  '_qz._slmw': 'Metsän sumu',
  '_qz._scld': 'Värien virtaus',
  '_qz._xdjz': 'Nykyaikainen arkkitehtuuri',

  '_qb._cbjl': 'Talletushistoria',
  '_qb._jyjl': 'Tapahtumahistoria',
  '_qb._bddz': 'Sidotut osoitteet',
  '_qb._txjl': 'Nostohistoria',

  '_m._tcdl': 'Kirjaudu ulos',
  '_m._cb': 'Talletta',
  '_m._tb': 'Nosta',

  '_cb._ssdz': 'Hae valuuttaa tai osoitetta',
  '_cb._bz': 'Valuutta',
  '_cb._je': 'Määrä',
  '_cb._dz': 'Osoite',
  '_cb._sj': 'Aika',
  '_cb._cz': 'Toiminto',
  '_cb._zwjl': 'Ei vielä tapahtumia',
  '_cb._dny': 'Sivu {a} / {b}',
  '_cb._jyxq': 'Tapauman tiedot',
  '_cb._jydz': 'Tapauman osoite',
  '_cb._zt': 'Tila',
  '_cb._yqr': 'Vahvistettu',
  '_cb._qb': 'Kaikki',
  '_cb._jt': 'Tänään',
  '_cb._j7t': 'Viimeiset 7 päivää',
  '_cb._j30t': 'Viimeiset 30 päivää',
  '_cb._zw': 'Ei mitään',
  '_cb._fzcg': 'Osoite kopioitu leikepöydälle',

  '_jyjl._ssdz': 'Hae valuuttaa tai osoitetta',
  '_jyjl._lx': 'Tyyppi',
  '_jyjl._je': 'Määrä',
  '_jyjl._ye': 'Saldo',
  '_jyjl._dj': 'Jäädytetty',
  '_jyjl._sj': 'Aika',
  '_jyjl._cz': 'Toiminto',
  '_jyjl._zwjyjl': 'Ei vielä tapahtumia',
  '_jyjl._czsx': 'Nollaa suodatin',
  '_jyjl._dny': 'Sivu {a} / {b}',
  '_jyjl._jyxq': 'Tapauman tiedot',
  '_jyjl._jylx': 'Tapauman tyyppi',
  '_jyjl._jyje': 'Tapauman määrä',
  '_jyjl._jyhye': 'Saldo tapauman jälkeen',
  '_jyjl._djye': 'Jäädytetty määrä',
  '_jyjl._jysj': 'Tapauman aika',
  '_jyjl._jyzt': 'Tapauman tila',
  '_jyjl._ywc': 'Valmis',
  '_jyjl._qb': 'Kaikki',
  '_jyjl._jt': 'Tänään',
  '_jyjl._j7t': 'Viimeiset 7 päivää',
  '_jyjl._j30t': 'Viimeiset 30 päivää',

  '_jyjl._tp1': 'Talletus',
  '_jyjl._tp2': 'Nosto',
  '_jyjl._tp3': 'Maksu',
  '_jyjl._tp4': 'Talletus',
  '_jyjl._tp5': 'Jäädy',
  '_jyjl._tp6': 'Tulot',
  '_jyjl._tp7': 'Kutsupalkkio',
  '_jyjl._tp8': 'Kirjautumispalkkio',
  '_jyjl._tp9': 'Mainonnan tulot',
  '_jyjl._tp10': 'Videopalkkio',
  '_jyjl._tp11': 'Rekisteröintibonus',
  '_jyjl._tp12': 'Nosto hylätty',
  '_jyjl._tp13': 'Viesti punainen paketti',

  '_jyjl._tp14': 'Sisäinen siirto',

  '_cb._shz': 'Tarkastettavana',
  '_cb._yyg': 'Hyväksytty',
  '_cb._ybh': 'Hylätty',

  '_bddz._tjdz': 'Lisää osoite',
  '_bddz._ssdz': 'Hae osoitetta',
  '_bddz._bz': 'Valuutta',
  '_bddz._dz': 'Osoite',
  '_bddz._sysj': 'Viimeksi käytetty',
  '_bddz._cz': 'Toiminto',
  '_bddz._zwjl': 'Ei osoitetietoja',
  '_bddz._dny': 'Sivu {a} / {b}',
  '_bddz._dzewm': 'Osoitteen QR-koodi',
  '_bddz._fzdz': 'Kopioi osoite',
  '_bddz._dzxq': 'Osoitteen tiedot',
  '_bddz._wl': 'Verkko',
  '_bddz._tjsj': 'Lisäysaika',
  '_bddz._bzwa': 'Huomio',
  '_bddz._ntq': '{a} päivää sitten',
  '_bddz._nxsq': '{a} tuntia sitten',
  '_bddz._nfzq': '{a} minuuttia sitten',
  '_bddz._ngg': 'Juuri nyt',
  '_bddz._dzyfz': 'Osoite kopioitu leikepöydälle',
  '_bddz._scqr': 'Poiston vahvistus',
  '_bddz._scqrdz': 'Haluatko varmasti poistaa tämän osoitteen?',
  '_bddz._qr': 'Vahvista',
  '_bddz._qx': 'Peruuta',
  '_bddz._scdzcg': 'Osoite poistettu onnistuneesti',

  '_txjl._ztsx': 'Tilan suodatus',
  '_txjl._qbzt': 'Kaikki tilat',
  '_txjl._shz': 'Tarkastettavana',
  '_txjl._ytg': 'Hyväksytty',
  '_txjl._yjj': 'Hylätty',
  '_txjl._ssdz': 'Hae osoitetta tai määrää',
  '_txjl._bz': 'Valuutta',
  '_txjl._je': 'Määrä',
  '_txjl._dz': 'Osoite',
  '_txjl._zt': 'Tila',
  '_txjl._sj': 'Aika',
  '_txjl._cz': 'Toiminto',
  '_txjl._zwjl': 'Ei vielä tapahtumia',
  '_txjl._czsx': 'Nollaa suodatin',
  '_txjl._dny': 'Sivu {a} / {b}',
  '_txjl._jyxq': 'Tapauman tiedot',
  '_txjl._skdz': 'Vastaanotto-osoite',
  '_txjl._jysj': 'Tapauman aika',
  '_txjl._jyzt': 'Tapauman tila',
  '_txjl._fzdz': 'Osoite kopioitu leikepöydälle',

  '_cbsq._bz': 'Valuutta',
  '_cbsq._wl': 'Verkko',
  '_cbsq._erwm': 'QR-koodi',
  '_cbsq._fzdz': 'Kopioi osoite',

  '_txsq._bz': 'Valuutta',
  '_txsq._wl': 'Verkko',
  '_txsq._ye': 'Saldo',
  '_txsq._sxf': 'Palkkio',
  '_txsq._zxtx': 'Miniminoiso',
  '_txsq._txdz': 'Nosto-osoite',
  '_txsq._qxztxdz': 'Valitse nosto-osoite',
  '_txsq._txje': 'Nostosumma',
  '_txsq._qsrtxje': 'Syötä nostosumma',
  '_txsq._yxyzm': 'Sähköpostin vahvistuskoodi',
  '_txsq._qsryxyzm': 'Syötä vahvistuskoodi',
  '_txsq._ljtx': 'Nosta nyt',

  '_jl._wxhd': 'Tykkäykseni',
  '_jl._lsjl': 'Historia',

  '_xx._bt': 'Viestikeskus',
  '_xx._wjl': 'Ei tietueita',
  '_xx._zsmyxx': 'Ei vielä viestejä',
  '_xx._sxxx': 'Päivitä viestit',
  '_xx._sxcg': 'Päivitetty onnistuneesti',

  '_fx._fxhy': 'Jaa ystävien kanssa',
  '_fx._smfx': 'Skannaa QR-koodi jakamiseen ystävien kanssa',
  '_fx._jlsm': 'Palkkion kuvaus',
  '_fx._jlsm1': '1. Suoraan kutsutut ystävät (Taso 1) antavat sinulle {a}% heidän tuloistaan.',
  '_fx._jlsm2': '2. Tason 1 ystäviesi kutsumat ystävät (Taso 2) antavat sinulle {a}% heidän tuloistaan.',
  '_fx._jlsm3': '3. Tason 2 ystäviesi kutsumat ystävät (Taso 3) antavat sinulle {a}% heidän tuloistaan.',
  '_fx._fzlj': 'Kopioi linkki',

  '_bzzx._bzzx': 'Ohjekeskus',
  '_bzzx._rhzczh': 'Kuinka luoda tili',
  '_bzzx._zclc': 'Rekisteröintiprosessi',
  '_bzzx._rhzcxyh': 'Kuinka rekisteröidä uusi tili?',
  '_bzzx._rhzcxyh1': 'Napsauta "Rekisteröidy"-painiketta, syötä sähköpostiosoite, aseta salasana ja suorita sähköpostin vahvistus onnistuneesti.',
  '_bzzx._rhcz': 'Kuinka täyttää saldoa?',
  '_bzzx._rhcz1': 'Täyttöprosessi',
  '_bzzx._rhcz2': 'Yksityiskohtaiset täyttöohjeet',
  '_bzzx._rhcz3': 'Napsauta Lompakkoni, Talletta, valitse haluttu kryptovaluutta ja lähetä annettuun osoitteeseen.',

  '_bzzx._rhjsdj': 'Kuinka avata lyhyt draama',
  '_bzzx._rhjsdj2': 'Napsauta avataksesi yksittäisiä jaksoja nähdäksesi enemmän sisältöä.',

  '_bzzx._rhtx': 'Kuinka nostaa tililtä',
  '_bzzx._rhtx1': '1. Siirry Lompakkoni, Nosto-osoitteet, lisää uusi nosto-osoite vastaavalle kryptovaluutalle.<br>2. Napsauta Nosta, valitse kryptovaluutta, valitse sidottu osoite, syötä nostosumma ja odota saapumista.',

  '_bzzx._qtwt': 'Muut kysymykset',
  '_bzzx._qtwt1': 'Kuinka ottaa yhteyttä asiakaspalveluun?',
  '_bzzx._qtwt2': 'Voit ottaa meihin yhteyttä verkkosivun oikeassa alakulmassa olevan asiakaspalvelun, sähköpostin tai puhelinnumeron kautta.',
  '_bzzx._myzdwt': 'Etkö löytänyt etsimääsi vastausta?',
  '_bzzx._khjybbzn': 'Asiakaspalvelutiimimme auttaa mielellään lisää.',
  '_bzzx._lxkf': 'Ota yhteyttä asiakaspalveluun',

  '_ggtf._bt1': 'Mainonnan sijoittaminen',
  '_ggtf._splb': 'Videolista',
  '_ggtf._wcyd': 'Osallistumiseni',
  '_ggtf._hdbm': 'Tapahtumakoodi',
  '_ggtf._tian': 'Päivää',
  '_ggtf._kssj': 'Aloitusaika',
  '_ggtf._jssj': 'Päättymisaika',
  '_ggtf._ddvp': 'Saavuta VIP-taso {a}, keskimäärin {b} osallistumista henkilöä kohden',
  '_ggtf._hdzt': 'Tapahtuman tila',
  '_ggtf._wks': 'Ei alkanut',
  '_ggtf._ycy': 'Osallistuttu',
  '_ggtf._qg': 'Osta nyt',
  '_ggtf._mygdl': 'Ei enempää tietoja',
  '_ggtf._qgrtd': 'Liian monta ostajaa, yritä uudelleen',
  '_ggtf._hdxq': 'Tapauman tiedot',
  '_ggtf._hdjs': 'Tapauman kuvaus',
  '_ggtf._cyyq': 'Osallistumisvaatimukset',
  '_ggtf._zdtz': 'Minimisijoitus',
  '_ggtf._vpdj': 'VIP-taso',
  '_ggtf._rjcy': 'Keskimääräinen osallistuminen',
  '_ggtf._gmje': 'Ostosumma',
  '_ggtf._qsrgmje': 'Syötä ostosumma',
  '_ggtf._qx': 'Peruuta',
  '_ggtf._ljcy': 'Osallistu nyt',
  '_ggtf._ssjymm': 'Syötä tapauman salasana',
  '_ggtf._qssjymm': 'Syötä tapauman salasana',
  '_ggtf._ji': 'Taso',
  '_ggtf._ci': 'kertaa',
  '_ggtf._zdgm': 'Minimiostosumma',
  '_ggtf._zggm': 'Maksimiostosumma',
  '_ggtf._zfz': 'Käsitellään maksua...',

  '_wdtg._wjl': 'Ei osallistumistietoja',
  '_wdtg._tzje': 'Sijoituksen määrä',
  '_wdtg._zsy': 'Kokonaistulot',
  '_wdtg._hdts': 'Tapauman päivät',
  '_wdtg._cysj': 'Osallistumisaika',
  '_wdtg._qzf': 'Maksa',
  '_wdtg._jxz': 'Käsittelyssä',
  '_wdtg._djszje': 'Määräaikaista selvitystä odottava summa',
  '_wdtg._gjb': 'Yhteensä {a} kohdetta',
  '_wdtg._djs': 'Odottaa selvitystä',
  '_wdtg._zrsy': 'Eilisen tulot',
  '_wdtg._dbl': 'Videotoistot',
  '_wdtg._bfl': 'Toistokerrat',
  '_wdtg._wdsy': 'Tuloni',
  '_wdtg._bqffc': 'Tekijänoikeudenomistajan osuus',
  '_wdtg._mr0djs': 'Selvitä eilisen tulot päivittäin klo 0:00',
  '_wdtg._jrsy': 'Päivän tulot',
  '_wdtg._mygd': 'Ei enempää tietoja',

  '_bqyy._bqyy': 'Tekijänoikeusyhteistyön varaaminen',
  '_bqyy._qrbq': 'Vahvista tekijänoikeusyhteistyön varaaminen?',
  '_bqyy._qx': 'Peruuta',
  '_bqyy._tjyy': 'Lähetä varaus',

  '_bqyy._spsq': 'Videotekijänoikeusyhteistyön hakemus',
  '_bqyy._spsy': 'Mainosta videoita yhdessä tekijänoikeudenhaltijoiden kanssa saadaksesi enemmän liikennettä ja tuloja!',
  '_bqyy._ljyy': 'Varaa nyt',
  '_bqyy._sphz': 'Mikä on Videotekijänoikeusyhteistyön hakemus?',
  '_bqyy._sphzsm': 'Videotekijänoikeusyhteistyön hakemus tarjoaa enemmän mainontamahdollisuuksia molempia hyödyttäväksi. Hakemuksen kautta saat tekijänoikeudenhaltijoiden tunnustuksen ja mahdollisuuden syvempään yhteistyöhön saadaksesi enemmän näkyvyyttä ja tuloja.',
  '_bqyy._sqhch': 'Tekijänoikeusyhteistyön edut',
  '_bqyy._llfz': 'Liikenteen tuki',
  '_bqyy._llfzsm': 'Saat alustan mainontamahdollisuuksia lisätäksesi näkyvyyttä ja toistokertoja.',
  '_bqyy._sytg': 'Lisääntyneet tulot',
  '_bqyy._sytgsm': 'Saat korkeamman mainostulojen osuuden ja liikeyhteistyömahdollisuuksia.',
  '_bqyy._yxhz': 'Etusijayhteistyö',
  '_bqyy._yxhzsm': 'Etusijaisuus alustan virallisissa tapahtumissa ja liikeyhteistyöhankkeissa.',
  '_bqyy._yytj': 'Varauksen ehdot',
  '_bqyy._sptg': 'Videomainonnan vaatimukset',
  '_bqyy._sptgsm': 'Osallistu vähintään 1 videomainontaan, joka täyttää alustan standardit.',
  '_bqyy._yysm': 'Klikkaamalla Varaa henkilökuntamme ottaa sinuun yhteyttä 3 arkipäivän kuluessa.',

  '_ybp._wdsy': 'Tuloni',
  '_ybp._dqye': 'Nykyinen saldo',
  '_ybp._jr': 'Tänään',
  '_ybp._jrzsy': 'Päivän kokonaistulot',
  '_ybp._ljzsy': 'Kokonaiskertymät',
  '_ybp._tgfh': 'Mainonnan osingot',
  '_ybp._ljsy': 'Kertyneet tulot',
  '_ybp._bqsy': 'Tekijänoikeustulot',
  '_ybp._yqfh': 'Kutsujen osingot',
  '_ybp._mrsy': 'Päivittäiset tulot',
  '_ybp._tgsy': 'Mainonnan tulot',

  '_tjdz._tjxd': 'Lisää uusi osoite',
  '_tjdz._xzbz': 'Valitse valuutta',
  '_tjdz._qbdz': 'Lompakon osoite',
  '_tjdz._srdz': 'Syötä lompakon osoite',
  '_tjdz._qx': 'Peruuta',
  '_tjdz._bc': 'Tallenna',

  '_sz._smrz': 'Henkilöllisyyden vahvistus',
  '_sz._rzlx': 'Vahvistuksen tyyppi',
  '_sz._sfzzm': 'Henkilökortin etupuoli',
  '_sz._sfzfm': 'Henkilökortin takapuoli',
  '_sz._zsxm': 'Oikea nimi',
  '_sz._qsrzsxm': 'Syötä oikea nimesi',
  '_sz._sfzhm': 'Henkilökortin numero',
  '_sz._qsrsfzhm': 'Syötä henkilökorttisi numero',
  '_sz._yyzz': 'Y-tunnus',
  '_sz._qymc': 'Yrityksen nimi',
  '_sz._yyzzh': 'Y-tunnusnumero',
  '_sz._qsrqymc': 'Syötä yrityksen nimi',
  '_sz._qsryyzzh': 'Syötä Y-tunnusnumero',
  '_sz._qx': 'Peruuta',
  '_sz._tjrz': 'Lähetä vahvistus',
  '_sz._zt': 'Tila',
  '_sz._gr': 'Yksityishenkilö',
  '_sz._qy': 'Yritys',
  '_sz._shz': 'Tarkastettavana',
  '_sz._ytg': 'Hyväksytty',
  '_sz._ybh': 'Hylätty',

  '_mm._xgmm': 'Vaihda salasana',
  '_mm._dqxg': 'Vaihda salasana säännöllisesti tilin turvallisuuden vuoksi',
  '_mm._dqmm': 'Nykyinen salasana',
  '_mm._xmm': 'Uusi salasana',
  '_mm._qrxmm': 'Vahvista uusi salasana',
  '_mm._qx': 'Peruuta',
  '_mm._qrxg': 'Vahvista vaihto',

  '_jymm._xgjymm': 'Vaihda tapauman salasana',

  '_szzx._sz': 'Asetukset',
  '_szzx._yrz': 'Vahvistettu',
  '_szzx._wrz': 'Ei vahvistettu',
  '_szzx._jymm': 'Tapauman salasana',
  '_szzx._szjymm': 'Aseta tai vaihda tapauman salasana',
  '_szzx._tcdl': 'Kirjaudu ulos',
  '_szzx._qdtcdl': 'Haluatko varmasti kirjautua ulos?',
  '_szzx._qrtc': 'Vahvista uloskirjautuminen',
  '_szzx._qx': 'Peruuta',

  '_yj._gy': 'Tietoja meistä',

  '_yj._lxwm': 'Ota yhteyttä',

  '_yj._yszc': 'Tietosuojakäytäntö',

  '_yj._yhxy': 'Käyttäjäsopimus',

  '_cd._gszz': 'Yrityksen pätevyysvaatimukset',

  '_cd._wmyy': 'Meillä on täydelliset alan pätevyydet ja sertifikaatit, ja tarjoamme käyttäjille laillisia, turvallisia ja korkealaatuisia videopalveluita',

  '_cd._yyzz': 'Voimassa oleva todiste yrityksen laillisesta toiminnasta, joka osoittaa viralliset rekisteröintitietomme ja liiketoimintamme laajuuden',

  '_cd._yyzz2': 'Laillisesti hankittu yrityksen sertifioima elinkeinolupa, joka varmistaa alustan laillisuuden ja vaatimustenmukaisuuden',

  '_bz._lxkf': 'Ota yhteyttä asiakaspalveluun napsauttamalla alla olevaa linkkiä tai ottamalla meihin yhteyttä asiakaspalvelun sähköpostitse tai puhelinlinjan kautta',

  '_sz._bjtx': 'Muokkaa',

  '_sz._bjxx': 'Muokkaa viestiä',

  '_sz._tx': 'Avatar',

  '_sz._bcun': 'Tallenna',

  '_db._zskf': 'Ota yhteyttä tukeen',
  '_db._zsry': 'Oma asiakaspalvelija',
  '_db._wdq': 'Lukematon',
  '_db._ydq': 'Luettu',

  '_sc._sctp': 'Lataa kuva',
  '_sc._xztp': 'Valitse kuva',
  '_sc._fstp': 'Lähetä kuva',
  '_sc._qx': 'Peruuta',
  '_sc._hd': 'Selvä',

  '_zcyl._zcbt': 'Rekisteröintibonus',
  '_zcyl._djdkhb': 'Napauta avataksesi punainen kirjekuori',
  '_zcyl._zclj': 'Rekisteröintipalkkio',
  '_zcyl._hmyzh': 'Ei tiliä vielä?',
  '_zcyl._qzc': 'Rekisteröidy',
  '_zcyl._qxdjhb': 'Nappaa palkkiosi ensin',
  '_zcyl._qwzc': 'Siirry rekisteröitymään',
  '_zcyl._hbysy': 'Palkkio on jo käytetty',

  '_ggtg._qhz': 'Siirry Siirtoon',
  '_ggtg._dqye': 'Nykyinen Saldo',
  '_ggtg._qcz': 'Siirry Täyttämiseen',
  '_ggtg._hzje': 'Siirtosumma',
  '_ggtg._ljhz': 'Siirrä Heti',
  '_ggtg._yebz': 'Riittämätön Saldo',

  '_sq._bhbt': 'Hylätty',

  '_sq._bhyy': 'Hylkäyksen syy',

  '_xx._ntq': '{n} päivää sitten',

  '_xx._nxsq': '{n} tuntia sitten',

  '_xx._nfzq': '{n} minuuttia sitten',

  '_xx._nggq': 'Juuri nyt',

  '_xx._djckgd': 'Klikkaa nähdäksesi lisää',

  '_ct._zt': 'Tila',

  '_ct._ljz': 'Yhdistetään',

  '_ct._ylj': 'Yhdistetty',

  '_ct._ltlieb': 'Keskustelulista',

  '_ct._bnhzj': 'En voi keskustella itseni kanssa',

  '_ct._cylb': 'Jäsenluettelo',

  '_hb._fhb': 'Punainen kirjekuori',

  '_hb._dqye': 'Nykyinen saldo',

  '_hb._fsd': 'Lähetetty',

  '_hb._hbje': 'Punaisen kirjekuoren summa',

  '_hb._qshuru': 'Anna punaisen kirjekuoren summa',

  '_hb._ljfs': 'Lähetä nyt',

  '_hb._hbz': 'Punaisen kirjekuoren siunaus',
  '_hb._qshuruzhu': 'Anna siunauksesi',

  '_sp._cuow': 'Jaksot 1–10 on avattava ennen kuin niitä voi katsoa',

  '_bq._tzzq': 'Sijoitusjakso',

  '_bq._zrsy': 'Eilinen voitto',

  '_bq._bqtz': 'Tekijänoikeussijoitus',

  '_bq._tzdj': 'Sijoitussumma',

  '_bq._zfjz': 'Maksu on suoritettava 24 tunnin kuluessa, muuten sitä pidetään vastuuvapautuksena!',

  '_bq._qzf': 'Suorita maksu',

  '_bq.jz': 'Määräaika',

  '_bq._ljzf': 'Maksa nyt',

  '_bq._sqbz': 'Hakemustiedot (valinnainen)',

  '_bq._sqbzsm': 'Anna hakemustiedot',

  '_bq._zzsqz': 'Tekijänoikeus hakemus on käsittelyssä, odottaa tarkistusta...',

  '_app._xz': 'Lataa ReelShortBiz-sovellus',

  '_app._smerm': 'Skannaa QR-koodi ladataksesi',

  '_app._xzbt': 'Lataa',

  '_m._yhzz': 'Pankkisiirto',
  '_m._yhxx': 'Pankkitiedot',
  '_m._yhmz': 'Pankin nimi',
  '_m._yhdz': 'Pankin osoite',
  '_m._yhmc': 'Nimi',
  '_m._yhzh': 'Tili',
  '_m._yhlx': 'Tyyppi',
  '_m._yhly': 'Reititys',
  '_m._yhdm': 'Koodi',
  '_m._yhbz': 'Huomautus',
  '_m._fzxx': 'Kopioi tiedot',

  '_m._zts': 'Vinkkejä',

  '_m._zyd1': '1. Tarkista huolellisesti vastaanottajan nimi, tilinumero ja pankkikoodi siirtäessäsi varoja. Mikä tahansa virhe voi johtaa maksun menettämiseen.',

  '_m._zyd2': "2. On suositeltavaa valita 'Maksajan vastuulla kaikki kulut', jotta vältetään riittämättömät varat välittäjäpankkien veloitusten vuoksi.",

  '_m._zyd3': '3. Siirrot kestävät yleensä 1–3 arkipäivää. Ole kärsivällinen. Jos sinulla on kysyttävää, ota yhteyttä asiakaspalveluun.',

  '_m._zyd4': '4. Jos sinulla on muita kysymyksiä, ota yhteyttä asiakaspalveluun.',

  '_m._jyh': 'Tapahtumanumero',

  '_m._jyje': 'Summa',

  '_sp._dbye': 'VOD-saldo',
  '_sp.hzye': 'Siirto',
  '_sp._txje': 'Siirtosumma',
  '_sp._qsrtxje': 'Anna siirtosumma',
  '_sp._ljhz': 'Siirrä nyt',
  '_sp._yebz': 'Riittämätön saldo',
  '_sp._qshuru': 'Anna oikea siirtosumma',
  '_sp._fanh': 'Takaisin',

  '_sp._tliu': 'Mainospaikoitus',
  '_sp._xzgj': 'Valitse maa',
  '_sp._cdcw': 'Videokoodausvirhe',
  '_ggtf._hot': 'Suosittu',
  '_tl._tlsj': 'Mainosaika',
  '_tl._xzxb': 'Valitse sukupuoli',
  '_tl._nan': 'Mies',
  '_tl._nv': 'Nainen',
  '_tl._hunhe': 'Sekoitettu',
  '_tl._xznl': 'Valitse ikä',
  '_sp._us': 'Yhdysvallat',
  '_sp._en': 'Iso-Britannia',
  '_sp._jp': 'Japani',
  '_sp._fr': 'Ranska',
  '_sp._kr': 'Etelä-Korea',
  '_sp._de': 'Saksa',
  '_sp._id': 'Intia',
  '_sp._in': 'Indonesia',
  '_sp._au': 'Australia',
  '_sp._es': 'Espanja',
  '_sp._my': 'Malesia',
  '_sp._cn': 'Kiina',
  '_ggtf._fanhui': 'Takaisin',
  '_ggtf._jymmts': 'Vahvista tapahtuman määrä ja syötä salasanasi',
  '_wdtg._wjl_desc': 'Et ole vielä osallistunut mainoskampanjoihin',
  '_wd._jxz': 'Käynnissä',
  '_wd._djs': 'Odottaa selvitystä',
  '_wd._ywc': 'Valmis',
  '_wd._jz': 'Kiireellinen',
  '_wd._hz': 'Siirto',

  '_tl._tlfbqk': 'Mainosmenojen jakautuminen',
  '_tl._tlfbqk_desc': 'Päivät 1-5: 5% (Kylmäkäynnistysvaihe), Päivät 6-10: 20% (Sisällön validointivaihe), Päivät 11-15: 40% (IP-rakennusvaihe), Päivät 16-20: 35% (Lyhytsarjamatriisivaihe)',

  '_nhz._sm': 'Siirron jälkeen summa siirretään videolompakkoon videosisällön avaamista varten',
  '_nhz._zhzz': 'Siirretään...',
  '_nhz._zzcg': 'Siirto onnistui',
  '_nhz._zhzsb': 'Siirto epäonnistui, yritä uudelleen',
  '_m._fzcg': 'Kopioitu onnistuneesti',
  '_m._fzsb': 'Kopiointi epäonnistui, kopioi manuaalisesti',
  '_m._zwfzxx': 'Ei kopioitavaa tietoa',
  '_tx._qb': 'Kaikki',
  'activity.detail': 'Aktiviteetin tiedot',
  'activity.noDesc': 'Ei aktiviteetin kuvausta',
  'activity.desc': 'Aktiviteetin kuvaus',
  'activity.requirements': 'Osallistumisvaatimukset',
  'activity.minInvest': 'Minimisijoitus',
  'activity.vipLevel': 'VIP-taso',
  'activity.avgParticipation': 'Keskimääräinen osallistuminen',
  'activity.avgParticipationDesc': 'kertaa',
  'activity.country': 'Valitse maa',
  'activity.deliveryTime': 'Mainosaika',
  'activity.deliveryTimeDesc': 'päivää',
  'activity.gender': 'Valitse sukupuoli',
  'activity.male': 'Mies',
  'activity.female': 'Nainen',
  'activity.mixed': 'Sekalainen',
  'activity.age': 'Valitse ikä',
  'activity.amount': 'Ostosumma',
  'activity.back': 'Takaisin',
  'activity.join': 'Osallistu nyt',
  emptyData: 'Ei tietoja',
  emptyDataDesc: 'Ei osallistuvia mainoskampanjoita',
  completedtlement: 'Vanhentunut',
  preheat: 'Esilämmitys',
  progress: 'Käynnissä',
  settlement: 'Odottaa selvitystä',
  transfered: 'Siirretty',
  completed: 'Valmis',
  activityCode: 'Aktiviteettikoodi',
  touzAmount: 'Sijoitusmäärä',
  activityDays: 'Aktiviteettipäivät',
  joinTime: 'Osallistumisaika',
  playSource: 'Toistolähteiden jakautuminen',
  allPlatforms: 'Kaikki alustat',
  other: 'Muu',
  totalPlayNum: 'Toistot yhteensä',
  incomeSummary: 'Tulojen yhteenveto',
  totalPay: 'Maksetut tekijänoikeusmaksut',
  totalIncome: 'Kokonaistulot',
  copyrightRatio: 'Tekijänoikeuden haltijan osuus',
  promotionIncome: 'Mainostulot',
  copyrightIncome: 'Tekijänoikeusosuus',
  playNum: 'Toistot',
  buyNum: 'Pyynnöstä toistot',
  incomeRate: 'Jakosuhde',
  yjIncome: 'Arvioidut tulot',
  paid: 'Maksettu',
  timeout: 'Aikakatkaisu',
  transfer: 'Siirrä nyt',
  loading: 'Ladataan...',
  loadMore: 'Lataa lisää',
  noMore: 'Ei enempää',
  nightTime: 'Yöaika',
  morningTime: 'Aamuaika',
  afternoonTime: 'Iltapäiväaika',
  eveningTime: 'Ilta-aika',
  '_h._tc': 'Kirjaudu ulos',
  periodPayment: 'Kausimaksu',
  periodPaymentDesc: 'Selvitys tapahtuu 4 kertaa päivässä 4 jaksona, voit maksaa tekijänoikeusmaksut jaksoittain',

  day: 'päivä',
  '_dl._hy': 'Tervetuloa takaisin',
  '_dl._cj': 'Luo tili',
  '_dl._zmm': 'Palauta salasana',
  '_dl._hyDesc': 'Kirjaudu tilillesi jatkaaksesi loistavan sisällön tutkimista',
  '_dl._cjDesc': 'Liity ReelShortBiziin ja aloita jännittävä matkasi',
  '_dl._zmmDesc': 'Syötä sähköpostiosoitteesi, lähetämme vahvistuskoodin palautusta varten',
  '_dl._hlgqsp': 'Laajat HD-elokuva- ja videoresurssit',
  '_dl._gxhty': 'Henkilökohtaiset suosittelualgoritmit',
  '_dl._ffddsp': 'Monipuoliset lyhytvideot',
  '_dl._dlzh': 'Kirjaudu sisään',
  '_dl._sdndyx': 'Syötä sähköpostiosoitteesi ja salasanasi jatkaaksesi',
  '_dl._email': 'Sähköpostiosoite',
  '_dl._qsryx': 'Syötä sähköpostiosoitteesi',
  '_dl._dlmm': 'Salasana',
  '_dl._qsrmm': 'Syötä salasanasi',
  '_dl._wjmm': 'Unohditko salasanan?',
  '_dl._immdl': 'Kirjaudu nyt',
  '_dl._hmyzh2': 'Eikö sinulla ole tiliä?',
  '_dl._ljzc2': 'Rekisteröidy nyt',
  '_dl._cjzh': 'Luo tili',
  '_dl._jswmd': 'Liity ReelShortBiziin ja aloita jännittävä matkasi',
  '_zh._qszmm': 'Aseta salasanasi',
  '_zh._qrmm': 'Vahvista salasana',
  '_zh._qmm': 'Syötä salasana uudelleen',
  '_zc._yqm': 'Kutsukoodi',
  '_zc._sryqm': 'Syötä kutsukoodi',
  '_dl._yzm': 'Vahvistuskoodi',
  '_dl._qsryzm': 'Syötä vahvistuskoodi',
  '_dl._yjyzh': 'Onko sinulla jo tili?',
  '_dl._zcbsty2': 'Rekisteröitymällä hyväksyt',
  '_dl._zcbstyDesc': 'Tietosuojakäytännön',
  '_dl._newmm': 'Uusi salasana',
  '_dl._qszxmm': 'Aseta uusi salasana',
  '_dl._qrmm': 'Vahvista salasana',
  '_dl._qzcsrmm': 'Syötä uusi salasana uudelleen',
  '_dl._czmm': 'Palauta salasana',
  '_dl._xqlmm': 'Muistitko salasanasi?',
  '_dl._fhdl': 'Palaa kirjautumiseen',
  '_dl._srdllmmbyz': 'Salasanat eivät täsmää',
  '_dl._czcg': 'Salasana palautettu onnistuneesti',
  '_h._zc': 'Rekisteröidy',
  // '_ybp._wdsy': 'Tuloni',
  '_ybp._jrsy': 'Tämän päivän tulot',
  '_ybp._jztr': 'Verrattuna eiliseen',
  '_ybp._bfl': 'Katselukerrat',
  '_ybp._dbl': 'Pyynnöt',
  '_ybp._syqs': 'Tulotrendi',
  // '_ybp._jr': 'Tänään',
  '_ybp._t': 'päivä',
  // '_ybp._dqye': 'Tilin saldo',
  '_ybp._djs': 'Odottaa selvitystä',
  '_ybp._zhl': 'Konversioprosentti',
  '_ybp._sjgl': 'Tietojen yleiskatsaus',
  '_ybp._zrsy': 'Eilisen tulot',
  '_ybp._bysy': 'Tämän kuukauden tulot',
  '_ybp._yysj': 'Toimintatiedot',
  '_ybp._zr': 'Eilen',
  '_ybp._zjfrs': 'Maksavat käyttäjät yhteensä',
  '_ybp._mtdqje': 'Huomenna maksettava summa',
  '_ybp._jsy': 'Nettotulot',
  '_ybp._bqfy': 'Tekijänoikeusmaksujen maksusuunnitelma',
  '_ybp._yzf': 'Maksettu',
  '_ybp._qzf': 'Mene maksamaan',
  '_ybp._bqfyts': 'Tekijänoikeusmaksujen maksamisen jälkeen tulosi ja oikeutesi priorisoidaan',
  '_ybp._syjl': 'Tulohistoria',
  '_ybp._ckgd': 'Näytä lisää',
  '_ybp._ssdt': 'Live-päivitykset',
  '_ybp._bzzx': 'Ohjekeskus',
  '_ybp._lxkf': 'Ota yhteyttä tukeen',
  '_ybp._zrxz': 'Eilisen tulot',
  '_ybp._zdsy': 'Kokonaistulot',
  '_ybp._qygy': 'Viime kuu',
  '_ybp._jsjl': 'Selvityshistoria',
  '_ybp._hzjl': 'Siirtohistoria',
  '_ybp._jfzq': 'minuuttia sitten',
  '_ybp._fzq': 'tuntia sitten',
  '_ybp._djs_mt': 'Huomisen selvityssumma',
  '_yj._rule': 'Alustasäännöt',

  '_bq._jjks': 'Aloita nyt',
  '_bq._jxz': 'Käynnissä',
  '_bq._jks': 'Aikaa alkuun',
  '_bq._jjs': 'Aikaa loppuun',
  '_bq._t': 'pv',
  '_bq._h': 't',
  '_bq._m': 'min',
  '_bq._s': 's',
  '_bq._kssj': 'Alkamisaika',
  '_bq._jssj': 'Päättymisaika',
  '_bqq._tzdj': 'Yksikköhinta',
  '_bqq._hdts': 'Tapahtumapäivät',
  '_bqq._vip': 'VIP-taso',
  '_bqq._rjcy': 'Keskimääräinen osallistuminen',
  '_bqq._cs': 'kertaa',
  '_bqq._ysjd': 'Myyntiedistymä',
  '_bqq._ljqg': 'Osta nyt',
  '_bqq._zbkqg': 'Ei tällä hetkellä saatavilla',
  '_bqq._jzz': 'Ladataan',
  '_bqq._jzgd': 'Lataa lisää',
  '_bqq._wz': 'Ei enempää',

  '_sp._gdsj': 'Yhteensä {n} jaksoa',
  '_sy._jl': 'Odottaa selvitystä',
  '_ybp._zsy': 'Kokonaistulot',
  '_ybp._djsjl': 'Odottaa selvitystä',
  '_ybp._bqbm': 'Koodi',
  '_ybp._je': 'Määrä',
  '_ybp._sj': 'Aika',
  '_sy._djs': 'Odottaa',
  '_sy._yjs': 'Selvitetty',
  '_sy._gdstjl': 'Yhteensä {n} tietuetta',
  '_sy._gjd': 'Yhteensä {n}',

  '_sp.tgdy':'Summa ei voi olla pienempi kuin {a}',
  '_sp.tggy':'Summa ei voi olla suurempi kuin {a}',

  '_tg._zdyje': 'Mukautettu summa'
}
